import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import type { CalendarPickerStore } from '../store/schema/CalendarPickerStore';
import getStore from '../store/store';

/**
 * Returns the calendar picker store instance for the given source ID.
 * @param scenarioId
 */
export default function getCalendarPickerStore(
    scenarioId: CalendarPickerScenarioId
): CalendarPickerStore {
    return getStore().scenarioStores.get(scenarioId);
}
